import { usePropertyStore } from "properties/propertyPage/PropertyContext";
import { PROPERTY_OPTION } from "_configs/propertyConfig";
import { Container } from "@material-ui/core";
import { PropertyBreadcrumb } from "properties/propertyPage/PropertyBreadcrumb";
import { PropertyViewInfo } from "properties/propertyPage/PropertyViewInfo";
import { PropertyViewGallery } from "properties/propertyPage/PropertyViewGallery";
import { PropertyHeaderLuxury } from "properties/propertyPage/PropertyHeaderLuxury";
import React from "react";

export const PropertyHeader = () => {
    const { property } = usePropertyStore();
    const isLuxury = !!property.features?.[PROPERTY_OPTION.luxury];

    return (
        <>
            {!isLuxury ? (
                <Container className={"!px-2.5"}>
                    <div className="mt-0 mx-0 mb-2 md:mt-5 flex-col sm:flex-row flex md:justify-between">
                        <PropertyBreadcrumb />
                        <PropertyViewInfo />
                    </div>
                    {!!property.photos.length && <PropertyViewGallery />}
                </Container>
            ) : (
                <PropertyHeaderLuxury />
            )}
        </>
    );
};
